import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e7556bf0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "section-container" };
const _hoisted_2 = { class: "section-header" };
const _hoisted_3 = { class: "section-footer viewer" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PricingTableColumnHeaders = _resolveComponent("PricingTableColumnHeaders");
    const _component_PricingTableRow = _resolveComponent("PricingTableRow");
    const _component_PricingTableSectionSummary = _resolveComponent("PricingTableSectionSummary");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.getSectionHeader(_ctx.sections, _ctx.sectionId)), 1),
        (!_ctx.isBlockWidthSmall)
            ? (_openBlock(), _createBlock(_component_PricingTableColumnHeaders, {
                key: 0,
                columns: _ctx.getColumns(_ctx.sections, _ctx.sectionId),
                "enabled-columns": _ctx.getEnabledColumns(_ctx.getColumns(_ctx.sections, _ctx.sectionId)),
                "grid-template-columns": _ctx.getGridTemplateColumns(_ctx.sections, _ctx.sectionId),
                class: "column-headers"
            }, null, 8, ["columns", "enabled-columns", "grid-template-columns"]))
            : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRowsSortedByColumnOrder(_ctx.sections, _ctx.sectionId), (row, index) => {
            return (_openBlock(), _createBlock(_component_PricingTableRow, {
                key: row.id,
                class: "sub-element",
                "data-external": `pricing-table-row-index:${index}`,
                "merge-values": _ctx.mergeValues,
                fields: _ctx.fields,
                recipient: _ctx.recipient,
                "allowed-to-edit-after-partially-signed": _ctx.allowedToEditAfterPartiallySigned,
                "recipient-input": _ctx.recipientInput,
                row: row,
                columns: _ctx.getColumns(_ctx.sections, _ctx.sectionId),
                context: _ctx.context,
                "grid-template-columns": _ctx.getGridTemplateColumns(_ctx.sections, _ctx.sectionId),
                "currency-settings": _ctx.currencySettings,
                "is-pre-calculated": _ctx.isPreCalculated,
                "is-block-width-small": _ctx.isBlockWidthSmall,
                onUpdateInputValue: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update-input-value', $event)))
            }, null, 8, ["data-external", "merge-values", "fields", "recipient", "allowed-to-edit-after-partially-signed", "recipient-input", "row", "columns", "context", "grid-template-columns", "currency-settings", "is-pre-calculated", "is-block-width-small"]));
        }), 128)),
        _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_PricingTableSectionSummary, {
                "section-summary": _ctx.getSectionSummary(_ctx.sections, _ctx.sectionId, _ctx.isPreCalculated, _ctx.fields),
                columns: _ctx.getColumns(_ctx.sections, _ctx.sectionId),
                "currency-settings": _ctx.currencySettings,
                "is-pre-calculated": _ctx.isPreCalculated,
                class: "sub-element viewer"
            }, null, 8, ["section-summary", "columns", "currency-settings", "is-pre-calculated"])
        ])
    ]));
}
